/**
 * It will show the circular spinner for giving user indication that something is happening
 *
 * @module views/components/LoaderCircular
 * @memberof -Common
 */
import './LoaderCircular.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { LoaderCircular as PalLoaderCircular } from 'web-palette/dist/components/LoaderCircular/LoaderCircular';

import { LOADER_CHILD_CLASS, LOADER_FIXED_CLASS } from '@ulta/core/components/Loader/Loader';
import { useIsMounted } from '@ulta/core/hooks/useIsMounted/useIsMounted';

/**
 * Represents a Loader component
 *
 * @method
 * @param {LoaderProps} props - React properties passed from composition
 * @returns Loader
 */
export const LoaderCircular = function( props ){
  const {
    isFixed = defaultProps.isFixed
  } = props;
  const isMounted = useIsMounted();

  const fixedClass = isMounted && isFixed ? LOADER_FIXED_CLASS : '';

  return (
    <div className={ classNames( 'LoaderCircular', LOADER_CHILD_CLASS, fixedClass ) }>
      <PalLoaderCircular
        color='primary'
      />
    </div>
  );
};

/**
 * Property type definitions
 *
 * @typedef LoaderProps
 * @type {object}
 * @property {string} isFixed - sets loader position to fixed
 */
export const propTypes =  {
  isFixed: PropTypes.bool
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} [isFixed=false] - Whether the loader is fixed by default
 */
export const defaultProps =  {
  isFixed: false
};

LoaderCircular.propTypes = propTypes;
LoaderCircular.defaultProps = defaultProps;

export default LoaderCircular;
